import { formatExternalUrl } from '@/utils/formatExternalUrl';
import { Box, BoxProps, Flex, IconButton } from '@chakra-ui/react';
import { DiscordIcon, GlobeIcon, TwitterIcon } from '@sphere/icons';
import { rem } from 'polished';

type Props = {
  discord?: string;
  twitter?: string;
  externalUrl?: string;
} & BoxProps;

export const CollectionSocials = ({ discord, twitter, externalUrl, ...boxProps }: Props) => {
  if (!discord && !twitter && !externalUrl) return null;

  return (
    <Box display="inline-block" {...boxProps}>
      <Flex
        gap="space.20"
        p="space.20"
        borderRadius="radius.12"
        background="gray.2"
        borderWidth="1px"
        borderColor="border"
      >
        {discord && (
          <IconButton
            as="a"
            variant="icon"
            icon={<DiscordIcon color="white" boxSize={rem(24)} />}
            aria-label="Discord"
            href={discord}
            target="_blank"
            rel="noopener noreferrer"
            boxSize={rem(24)}
            transition="opacity 120ms ease-in-out"
            _hover={{ opacity: 0.6 }}
          />
        )}
        {twitter && (
          <IconButton
            as="a"
            variant="icon"
            icon={<TwitterIcon boxSize={rem(24)} />}
            aria-label="Discord"
            href={twitter}
            target="_blank"
            rel="noopener noreferrer"
            boxSize={rem(24)}
            transition="opacity 120ms ease-in-out"
            _hover={{ opacity: 0.6 }}
          />
        )}
        {externalUrl && (
          <IconButton
            as="a"
            variant="icon"
            icon={<GlobeIcon boxSize={rem(24)} />}
            aria-label="Website"
            href={formatExternalUrl(externalUrl)}
            target="_blank"
            rel="noopener noreferrer"
            boxSize={rem(24)}
            transition="opacity 120ms ease-in-out"
            _hover={{ opacity: 0.6 }}
          />
        )}
      </Flex>
    </Box>
  );
};
